import { enqueueSnackbar } from "notistack";

export const handleResponse = ({
  response = null,
  setTitle,
  setMetaData,
  successMessage,
}) => {
  if (!response) return;
  if (response?.result) {
    enqueueSnackbar(successMessage || "Operation Completed Successfully", {
      variant: "success",
    });
    return;
  }
  if (response?.error) {
    if (setTitle) {
      const title = response?.error?.message?.toLowerCase();
      const errorName = response?.error?.data?.name;
      console.log("response", response, errorName, title);
      if (errorName.includes("odoo.exceptions.ValidationError")) {
        setTitle(title.replaceAll("odoo server error", "Validation Error"));
      } else if (title?.includes("odoo")) {
        setTitle(title.replaceAll("odoo", ""));
      } else {
        setTitle(title);
      }
    }
    if (setMetaData) {
      setMetaData({
        dangerouslySetInnerHTML:
          response?.error?.data?.message || "Somthing Went Wrong",
        secondaryButton: "Ok",
        primaryButton: "",
      });
    }
  }
};
